/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"
import { Typography, Link } from "@material-ui/core"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
        }}
      >
        <main>{children}</main>
        <footer>
          <Typography variant="body2" color="textSecondary" align="center">
            This site is an implementation of
            {" "}
            <Link href="https://github.com/ethereum/EIPs/pull/2381" target="_blank" rel="noreferrer">EIP 2381.</Link>
            {" "}
            Built by
            {" "}
            <Link color="inherit" href="https://oisin.kyne.eu/" target="_blank" rel="noreferrer">
              Kyne Software
            </Link>
            {'.'}
          </Typography>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
